<template>
  <div>
    <vx-card class="mt-10">
      <table>
        <tr>
          <td>
            <vs-input
              label="Excel File"
              type="file"
              size="small"
              accept=".xlsx"
              @change="previewFiles"
            />
            &nbsp;
          </td>
          <td>
            <vs-button
              icon-pack="feather"
              icon="icon-arrow-down"
              color="primary"
              size="medium"
              class="ml-5"
              @click="exportExcel"
            >
              Download Format</vs-button
            >
          </td>
          <td>
            <vs-alert color="primary" active="true" class="ml-3">
              Data Upload: {{ excelData.length }}
            </vs-alert>
          </td>
          <td>
            <vs-alert color="success" active="true" class="ml-3">
              Data Status Berhasil: {{ dataSukses.length }}
            </vs-alert>
          </td>
          <td>
            <vs-alert color="danger" active="true" class="ml-3">
              Data Status tidak Berhasil: {{ dataGagal.length }}
            </vs-alert>
          </td>
          <td>
            <vs-alert
              color="warning"
              active="true"
              class="ml-3"
              v-if="excelData.length > 0"
            >
              Data Yang diupload hanyalah data yang statusnya BERHASIL
            </vs-alert>
          </td>
        </tr>
      </table>

      <vxe-table
        :loading="loadingTable"
        empty-text="Empty Data "
        keep-source
        border
        show-overflow
        show-header-overflow
        ref="xTable"
        height="500"
        size="mini"
        :row-style="rowStyle"
        row-key
        highlight-hover-row
        highlight-current-row
        :row-config="{ isCurrent: true, isHover: true, height: 35 }"
        :column-config="{ resizable: true }"
        :data="excelData"
        :mouse-config="{ selected: true }"
        :checkbox-config="{
          highlight: true,
          range: true,
        }"
        :keyboard-config="{
          isArrow: true,
          isDel: true,
          isEnter: true,
          isTab: true,
          isEdit: true,
        }"
        :edit-config="{
          trigger: 'dblclick',
          mode: 'cell',
          showStatus: true,
        }"
        :scroll-y="{ mode: 'wheel' }"
        @cell-click="cellClickEvent"
      >
        >
        <vxe-column type="seq" width="60"></vxe-column>
        <vxe-column
          width="100"
          field="info"
          title="STATUS"
          header-align="center"
          sortable
          :filters="[
            { label: 'Berhasil', value: 'Berhasil' },
            { label: 'Gagal', value: 'Gagal' },
          ]"
          :filter-method="filterInfo"
        >
        </vxe-column>
        <vxe-column
          width="150"
          align="left"
          field="nomorKaryawan"
          title="NO KARYAWAN"
          header-align="center"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.nomorKaryawan" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="left"
          field="noIdentitas"
          title="NO IDENTITAS"
          header-align="center"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.noIdentitas" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="left"
          field="noKk"
          title="NO KK"
          header-align="center"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.noKk" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="left"
          field="npwp"
          title="NPWP"
          header-align="center"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.npwp" />
          </template>
        </vxe-column>

        <vxe-column
          width="150"
          align="center"
          field="nama"
          title="NAME"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.nama" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="currency"
          title="CURRENCY"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <v-select
              size="mini"
              :options="optionCurrency"
              v-model="row.currency"
            ></v-select>
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="department"
          title="DEPARTMENT"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.department" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="bagian"
          title="PART"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.bagian" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="posisi"
          title="POSITION"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.position" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="tglMasuk"
          :formatter="$$formatDate"
          title="JOIN DATE"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input type="date" v-model="row.tglMasuk" />
          </template>
        </vxe-column>

        <vxe-column
          width="150"
          align="center"
          field="tempatLahir"
          title="PLACE OF BIRTH"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.tempatLahir" />
          </template>
        </vxe-column>

        <vxe-column
          width="150"
          align="center"
          field="tglLahir"
          title="DATE OF BIRTH"
          :edit-render="{}"
        >
          <template #default="{ row }">
            <p>
              {{ $formatDatemoment(row.tglLahir) }}
            </p>
          </template>
          <template #edit="{ row }">
            <vxe-input v-model="row.tglLahir" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="hariLahir"
          title="DAY OF BIRTH"
          :edit-render="{}"
        >
          <template #default="{ row }">
            <p>
              {{ row.tglLahir != null ? row.tglLahir.getDay() : "" }}
            </p>
          </template>
          <template #edit="{ row }">
            <vxe-input v-model="row.hariLahir" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="alamat"
          title="ADDRESS"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.alamat" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="noTelp"
          title="PHONE NUMBER"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.noTelp" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="noWhatsapp"
          title="WHATSAPP NUMBER"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.noWhatsapp" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="email"
          title="EMAIL"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.email" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="sma"
          title="SHS"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.sma" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="universitas"
          title="UNIVERSITY"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.universitas" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="akhir"
          title="END"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.akhir" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="lembagaKeuangan"
          title="FINANCIAL INTUITIONS"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.lembagaKeuangan" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="pemilikAkun"
          title="ACCOUNT OWNER"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.pemilikAkun" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="akun"
          title="ACCOUNT"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.akun" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="statusPernikahan"
          title="STATUS PTKP"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.statusPernikahan" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="statusMarriage"
          title="MARITAL STATUS"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.statusMarriage" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="jumlahAnak"
          title="NUMBER OF CHILDREN"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.jumlahAnak" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="center"
          field="kendaraanPribadi"
          title="PRIVATE VEHICLE"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.kendaraanPribadi" />
          </template>
        </vxe-column>

        <vxe-column
          width="150"
          align="left"
          field="bpjsKesehatan"
          title="BPJS KESEHATAN"
          header-align="center"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.bpjsKesehatan" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="left"
          field="bpjsKerja"
          title="BPJS KETENAGAKERJAAN"
          head-align="center"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.bpjsKerja" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="left"
          field="premiAsuransiPerusahaan"
          title="PREMI ASURANSI PERSH"
          head-align="center"
          :edit-render="{}"
        >
          <template #edit="{ row }">
            <vxe-input v-model="row.premiAsuransiPerusahaan" />
          </template>
        </vxe-column>
        <vxe-column
          width="150"
          align="left"
          field="isBpjs"
          title="BPJS"
          head-align="center"
        >
        </vxe-column>
        <vxe-column
          width="150"
          align="left"
          field="isTka"
          title="TKA"
          head-align="center"
        >
        </vxe-column>
      </vxe-table>
      <vs-button
        v-if="excelData.length > 0"
        transparent
        size="medium"
        icon-pack="feather"
        icon="icon-save"
        color="primary"
        @click="confirmUpload()"
        >Simpan</vs-button
      >
    </vx-card>
  </div>
</template>
<script>
import { PerfectScrollbar } from "vue2-perfect-scrollbar";

import { SweetModal, SweetModalTab } from "sweet-modal-vue";

import XLSX from "xlsx";

import moment from "moment";
export default {
  props: {
    test: String,
    method: {
      type: Function,
    },
  },
  components: {
    PerfectScrollbar,
    SweetModal,
    SweetModalTab,
  },
  data() {
    return {
      optionCurrency: [],
      optionsPernikahan: [],
      optionPosisi: [],
      optionBagian: [],
      optionDepartment: [],
      tableToolbar: {
        export: true,
        zoom: true,
      },
      showDetails: false,
      index: "",
      loadingTable: false,
      noreg: "",
      remark: "",
      tglInput: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      excelData: [],
      dataSukses: [],
      dataGagal: [],
      dataUpload: [],
      userId: "",
      noBap: "",
      datastok: [],
      contacts: [],
      selectRow: {},
      format: "yyyy-MM-dd",
    };
  },
  methods: {
    async getCurrency() {
      const res = this.$api.get("/api/v1/masterdata/currency");
      this.optionCurrency = res.data.content;
    },
    rowStyle({ row }) {
      if (row.info != "Berhasil") {
        return { backgroundColor: "red", color: "white" };
      }
    },
    formatterDate({ cellValue }) {
      return moment(cellValue).format("yyyy-MM-DD");
    },
    formatDate(cell) {
      return moment(cell).format("yyyy-MM-DD");
    },
    filterInfo({ value, row, column }) {
      // console.log(value);
      if (value == "Gagal") {
        return row.info != "Berhasil";
      } else {
        return row.info == value;
      }
    },
    filterDokumen({ option, row }) {
      return row.noUrut === Number(option.data);
    },
    formatterNum({ cellValue }) {
      return cellValue.toFixed(2);
    },
    cellClickEvent({ row }) {
      this.showDetails = true;
      this.selectRow = row;
    },
    getReg(urut) {
      var date = new Date();
      var day = date.getDate();
      if (day < 10) day = "0" + day;
      var month = (date.getMonth() + 1).toString().padStart(2, "0");
      var year = date.getFullYear();

      var hour = date.getHours();
      var minutes = date.getMinutes();
      var sec = date.getSeconds();

      var seedatetime =
        "IN-" + year + month + day + "-" + hour + minutes + sec + urut;

      return seedatetime;
    },
    confirmUpload() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Apakah Yakin?`,
        text: `Upload data yang berhasil ?`,
        accept: async () => {
          this.uploadAll();
        },
      });
    },

    async uploadAll() {
      try {
        this.$vs.loading({ text: "Mohon tunggu, sedang melakukan Upload" });
        this.excelData = this.excelData.filter((f) => f.info == "Berhasil");

        await this.$api.post(
          "api/v1/hrd/masterdata/karyawan/importkaryawanall",
          this.excelData
        );
        setTimeout(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: "Upload Master Data Karyawan",
            title: this.$t("berhasil"),
            color: "success",
          });
          this.$router.push("/hrd/masterdata/karyawan");
        }, 1);
      } catch (error) {
        this.$vs.loading.close();
        this.$notify({
          offset: 200,
          duration: 5000,
          title: "ERROR",
          type: "error",
          message: "CATCHING ERROR",
        });
        // this.$vs.loading({ text: "Error: Hubungi developer" });
      }
    },
    exportExcel() {
      let headers = [
        {
          "EMPLOYEE NO": "",
          "IDENTITY NO": "",
          "FAMILY CARD NO": "",
          "TAX ID NO": "",
          NAME: "",
          "GENDER (M/F)": "",
          "CONTRACT STATUS": "",
          "CONTRACT DATE (yyyy/MM/DD)": "",
          "DEPARTMENT (CODE / NAME IN MASTER)": "",
          "SECTION (CODE / NAME IN MASTER)": "",
          "POSITION (CODE / NAME IN MASTER)": "",
          "JOINING DATE (yyyy/MM/DD)": "",
          "PLACE OF BIRTH": "",
          "DATE OF BIRTH (yyyy/MM/DD)": "",

          ADDRESS: "",
          "PHONE NO": "",
          EMAIL: "",
          "WHATSAPP NUMBER": "",
          "HIGH SCHOOL": "",
          UNIVERSITY: "",
          "LAST EDUCATION": "",
          "FINANCIAL INSTITUTION/BANK": "",
          "ACCOUNT NO": "",
          "ACCOUNT NAME": "",
          "PTKP STATUS": "",
          "MARITAL STATUS (TK/SK)": "",
          "NUMBER OF CHILDREN": "",
          "PRIVATE VEHICLE": "",
          "HEALTH INSURANCE (BPJS)": "",
          "EMPLOYMENT INSURANCE (BPJS)": "",
          "COMPANY INSURANCE PREMIUM": "",
          "FOREIGN WORKER (Y/N)": "",
          CURRENCY: "",
          "PARTICIPATE IN BPJS (Y/N)": "",
        },
      ];
      const data = XLSX.utils.json_to_sheet(headers);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `Format Upload Master ${this.$t("employee")}.xlsx`);
    },
    async previewFiles(e) {
      const file = e.target.files[0];
      var reader = new FileReader();
      this.excelData = [];
      let tmp0 = [];
      let t = this;
      this.loadingTable = true;
      try {
        reader.onload = function (e) {
          var data = new Uint8Array(e.target.result);
          var workbook = XLSX.read(data, {
            type: "array",
          });
          var firstSheet = workbook.SheetNames[0];
          const elements = XLSX.utils.sheet_to_json(
            workbook.Sheets[firstSheet]
          );

          elements.forEach((el, i) => {
            t.excelData.push({
              nomorKaryawan: el["EMPLOYEE NO"],
              noIdentitas: el["IDENTITY NO"],
              noKk: el["FAMILY CARD NO"],
              npwp: el["TAX ID NO"],
              nama: el["NAME"],
              currency: el["CURRENCY"],
              jenisKelamin: el["GENDER (M/F)"],
              statusKontrak: el["CONTRACT STATUS"],
              tglKontrak: el["CONTRACT DATE (yyyy/MM/DD)"],
              department: el["DEPARTMENT (CODE / NAME IN MASTER)"],
              bagian: el["SECTION (CODE / NAME IN MASTER)"],
              posisi: el["POSITION (CODE / NAME IN MASTER)"],
              tglMasuk: el["JOINING DATE (yyyy/MM/DD)"],
              tempatLahir: el["PLACE OF BIRTH"],
              tglLahir: el["DATE OF BIRTH (yyyy/MM/DD)"],
              alamat: el["ADDRESS"],
              noTelp: el["PHONE NO"],
              email: el["EMAIL"],
              noWhatsapp: el["WHATSAPP NUMBER"],
              sma: el["HIGH SCHOOL"],
              universitas: el["UNIVERSITY"],
              akhir: el["LAST EDUCATION"],
              lembagaKeuangan: el["FINANCIAL INSTITUTION/BANK"],
              akun: el["ACCOUNT NO"],
              pemilikAkun: el["ACCOUNT NAME"],
              statusMarriage: el["MARITAL STATUS (TK/SK)"],
              statusPernikahan: el["PTKP STATUS"],
              jumlahAnak: el["NUMBER OF CHILDREN"],
              kendaraanPribadi: el["PRIVATE VEHICLE"],
              bpjsKesehatan: el["HEALTH INSURANCE (BPJS)"],
              bpjsKerja: el["EMPLOYMENT INSURANCE (BPJS)"],
              premiAsuransiPerusahaan: el["COMPANY INSURANCE PREMIUM"],
              isTka:
                el["FOREIGN WORKER (Y/N)"] &&
                el["FOREIGN WORKER (Y/N)"].toLowerCase() == "y"
                  ? true
                  : false,
              isBpjs:
                el["PARTICIPATE IN BPJS (Y/N)"] &&
                el["PARTICIPATE IN BPJS (Y/N)"].toLowerCase() == "y"
                  ? true
                  : false,

              index: i,
              info: "Berhasil",
            });
          });

          t.loadingTable = false;
          t.validasiData1();
        };
        // this.excelData = JSON.parse(JSON.stringify(tmp0));
        this.loadingTable = false;
        reader.readAsArrayBuffer(file);
      } catch (error) {
        console.log(error);
      }
    },
    async getPernikahan() {
      let get = await this.$api.get("api/v1/hrd/lainnya/ptkp");
      this.optionsPernikahan = get.data.map((m) => {
        return m;
      });
    },

    async validasiData1() {
      try {
        let validasi = ["", null, undefined];
        // this.$vs.loading();
        this.loadingTable = true;
        this.$vs.notify({
          text: "Validation 1",
          color: "success",
          title: this.$t("berhasil"),
          iconPack: "feather",
          icon: "icon-check",
          time: 4000,
        });

        // let data = this.excelData[0];

        this.excelData.forEach((e) => {
          if (validasi.includes(e.nama)) e.info = "NAMA GAGAL";
          if (validasi.includes(e.nomorKaryawan))
            e.info = "NOMOR KARYAWAN GAGAL";
          if (validasi.includes(e.noIdentitas))
            e.info = "NOMOR IDENTITAS GAGAL";

          // if (validasi.includes(e.department)) {
          //   e.info = "DEPARTMENT GAGAL";
          // } else {
          //   let department = this.optionDepartment.filter(
          //     (f) =>
          //       f.kodeDepartment == e.department ||
          //       f.namaDepartment == e.department
          //   );
          //   if (department.length > 0) {
          //     e.kodeDepartment = department[0].kodeDepartment;
          //     e.department = department[0].namaDepartment;
          //   } else {
          //     e.info = "DEPARTMENT GAGAL";
          //   }
          // }

          // if (validasi.includes(e.posisi)) {
          //   e.info = "POSISI GAGAL";
          // } else {
          //   let posisi = this.optionPosisi.filter(
          //     (f) => f.kodePosisi == e.posisi || f.namaPosisi == e.posisi
          //   );
          //   if (posisi.length > 0) {
          //     e.kodePosisi = posisi[0].kodePosisi;
          //     e.posisi = posisi[0].namaPosisi;
          //   } else {
          //     e.info = "POSISI GAGAL";
          //   }
          // }

          if (validasi.includes(e.bagian)) {
            // e.info = "BAGIAN GAGAL";
          } else {
            let bagian = this.optionBagian.filter(
              (f) => f.kodeBagian == e.bagian || f.namaBagian == e.bagian
            );
            if (bagian.length > 0) {
              e.kodeBagian = bagian[0].kodeBagian;
              e.bagian = bagian[0].namaBagian;
            } else {
              // e.info = "BAGIAN GAGAL";
            }
          }

          if (validasi.includes(e.tglKontrak)) {
            // e.info = "Tanggal Kontrak Gagal";
          } else {
            e.tglKontrak = moment(this.ExcelDateToJSDate(e.tglKontrak)).format(
              "yyyy-MM-DD"
            );
          }

          if (!e.tglLahir) {
            e.info = "Tanggal Lahir Diperlukan";
          } else {
            if (typeof e.tglLahir == "number") {
              e.tglLahir = this.ExcelDateToJSDate(e.tglLahir);
            } else {
              e.tglLahir = new Date(e.tglLahir);
            }
          }
          if (e.gajiPokok && isNaN(e.gajiPokok)) {
            e.gajiPokok = 0;
          }
          if (e.premiAsuransiPerusahaan && isNaN(e.premiAsuransiPerusahaan)) {
            e.premiAsuransiPerusahaan = 0;
          }

          // if (!e.statusPernikahan) {
          //   e.info = "STATUS PTKP DIPERLUKANS";
          // } else {
          //   let cekPtkp = this.optionsPernikahan.find(
          //     (f) => f.kodePtkp == e.statusPernikahan
          //   );
          //   if (!cekPtkp) {
          //     e.info = "STATUS PTKP TIDAK DITEMUKAN";
          //   }
          // }

          if (!e.tglMasuk) {
            e.info = "Tanggal Masuk Diperlukan";
          } else {
            if (typeof e.tglMasuk == "number") {
              e.tglMasuk = this.ExcelDateToJSDate(e.tglMasuk);
            } else {
              e.tglMasuk = new Date(e.tglMasuk);
            }
          }
        });

        this.loadingTable = false;
        this.validasiData2();
      } catch (error) {
        console.log(error);
        this.loadingTable = false;
        this.$vs.loading({ text: "error: hubungi developer" });
      }
    },
    async validasiData2() {
      //cek kode Barang nya
      try {
        this.$vs.notify({
          text:
            this.$store.state.userLang == "id"
              ? "Memasuki tahap validasi 2: Validasi NO KARYAWAN"
              : "Entering validation stage 2: Validation NO EMPLOYEE",
          color: "success",
          title: this.$t("berhasil"),
          iconPack: "feather",
          icon: "icon-check",
          time: 4000,
        });

        this.$vs.loading({
          text:
            this.$store.state.userLang == "id"
              ? "Mohon tunggu, Melakukan validasi ke server"
              : "Please wait, Validating to server",
        });
        this.loadingTable = true;

        let get = await this.$api.post(
          "api/v1/hrd/masterdata/karyawan/ceknomor",
          this.excelData
        );

        get.data.content.forEach((e, i) => {
          if (e.status == "Sudah Ada") {
            this.excelData[i]["info"] = "Nomor Karyawan sudah ada";
          }
        });

        setTimeout(() => {
          this.loadingTable = false;

          this.$vs.loading.close();
        }, 1);
      } catch (error) {
        console.log(error);
        this.$vs.loading.close();
        this.$notify({
          type: "error",
          title: "ERROR",
          message: "Error terdeteksi",
          offset: 200,
          duration: 10000,
        });
        // this.$vs.loading({
        //   text: "error: hubungi developer",
        // });
      }
    },

    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

      var total_seconds = Math.floor(86400 * fractional_day);

      var seconds = total_seconds % 60;

      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      return new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds
      );
    },

    getUniqueListBy(arr, key) {
      return [...new Map(arr.map((item) => [item[key], item])).values()];
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "TOTAL";
          }
          if (["jmlMasuk"].includes(column.property)) {
            let a = data.reduce(function (sum, current) {
              return sum + current.jmlMasuk;
            }, 0);
            return a.toFixed(2);
          }
          if (["amount"].includes(column.property)) {
            let a = data.reduce(function (sum, current) {
              return sum + current.amount;
            }, 0);
            return a.toFixed(2);
          }
          return null;
        }),
      ];
    },

    notif(title, text, color) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text,
      });
    },
    compareValues(key, order = "asc") {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },
    async getDepartment() {
      try {
        await this.$api.get("api/v1/hrd/masterdata/department").then((res) => {
          res.data.map((item) =>
            this.optionDepartment.push({
              kodeDepartment: item.kodeDepartment,
              namaDepartment: item.namaDepartment,
              label: `${item.namaDepartment}`,
            })
          );

          console.log("array:" + this.optionDepartment);
          console.log(
            "namaDepartment : " + this.optionDepartment[0].namaDepartment
          );
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getBagian() {
      await this.$api.get("api/v1/hrd/masterdata/bagian").then((res) => {
        res.data.map((item) =>
          this.optionBagian.push({
            kodeBagian: item.kodeBagian,
            namaBagian: item.namaBagian,
            label: `${item.namaBagian}`,
          })
        );
      });
      console.log("Option Posisi : " + this.optionBagian);
    },
    async getPosisi() {
      await this.$api.get("api/v1/hrd/masterdata/posisi").then((res) => {
        res.data.map((item) =>
          this.optionPosisi.push({
            kodePosisi: item.kodePosisi,
            namaPosisi: item.namaPosisi,
            label: `${item.namaPosisi}`,
          })
        );
      });
      console.log("Option Posisi: " + this.optionPosisi);
    },
  },
  async mounted() {
    this.getDepartment();
    this.getBagian();
    this.getPosisi();
    this.getCurrency();
    this.getPernikahan();
    // console.log(this.XEUtils);
    this.tglInput = new Date(this.tglInput).toISOString().split("T")[0];
    var date = new Date();
    var year = date.getFullYear();
    var month = (date.getMonth() + 1).toString().padStart(2, "0");

    var day = date.getDate().toString().padStart(2, "0");

    var hour = date.getHours();
    var minutes = date.getMinutes();
    var sec = date.getSeconds();

    var seedatetime =
      "ADDIN-" + year + month + day + "-" + hour + minutes + sec;
    this.tglKeluar = year + "-" + month + "-" + day;
    this.noreg = seedatetime;
  },
};
</script>
